<div
  class="cads-info-badge-bit"
  [class.cads-info-badge-bit--accent]="hasAccent()"
  [ngStyle]="accentCssVars()"
  role="group"
  [attr.aria-label]="_ariaLabel()"
>
  <span class="cads-info-badge-bit__icon material-symbols-outlined" aria-hidden="true">{{ config().leadingIcon }}</span>
  <span class="cads-info-badge-bit__text">
    <span class="cads-info-badge-bit__label">{{ config().label }}</span>
    <strong class="cads-info-badge-bit__strong">{{ config().boldSuffix }}</strong>
  </span>
</div>
